import React from "react";
import { IControlStyles, useControlStyles } from "../.";
import { ComponentProps, ControlInput, ControlTemplateProps } from "../misc/controlInput";

export interface ControlTextAreaProps extends ControlTemplateProps {
    rows: number;
}

export const ControlTextArea: React.FC<ControlTextAreaProps> = (props) => {
    const styles: IControlStyles = props.controlStyles ??  useControlStyles();
    
    return (
        <ControlInput type="textarea" {...ComponentProps(props)} style={{ ...styles.textArea ?? styles.text ?? styles.input, ...props.style }} />        
    );
};